import { useToggle, upperFirst } from '@mantine/hooks'
import { useForm } from '@mantine/form'

import { useSupabaseClient } from '@supabase/auth-helpers-react'

import { useState } from 'react'

import {
    TextInput,
    PasswordInput,
    Text,
    Paper,
    Group,
    Container,
    Title,
    Button,
    Divider,
    Checkbox,
    Anchor,
    Stack,
    AppShell,
} from '@mantine/core'

import { useTranslation } from 'react-i18next'

export default function AuthenticationForm(props) {
    const { t } = useTranslation()

    const [type, toggle] = useToggle(['login', 'register'])

    const [isLoading, setIsLoading] = useState(false)

    const supabaseClient = useSupabaseClient()

    const lastUser = JSON.parse(localStorage.getItem('last_user') || 'null')

    const form = useForm({
        initialValues: {
            email: lastUser?.email ?? '',
            name: '',
            password: '',
            terms: true,
        },

        validate: {
            email: (val) => (/^\S+@\S+$/.test(val) ? null : 'Invalid email'),
        },
    })

    const formOnSubmit = form.onSubmit(async ({ email, password }) => {
        setIsLoading(true)

        const { error } = await supabaseClient.auth.signInWithPassword({
            email,
            password,
        })

        if (error) {
            setIsLoading(false)
            form.setFieldError('password', 'Mot de passe incorrect')
        }
    })

    const sendOTPCode = async () => {
        /*
        const { data, error } = await supabaseClient.auth.signInWithOtp({
            email: 'thomas@baltic-watches.com',
        })
        */
    }

    return (
        <form onSubmit={formOnSubmit}>
            <Stack>
                <TextInput
                    required
                    label={t('email')}
                    type="email"
                    placeholder={t('email_placeholder')}
                    withAsterisk={false}
                    value={form.values.email}
                    onChange={(event) =>
                        form.setFieldValue('email', event.currentTarget.value)
                    }
                    error={form.errors.email && 'Invalid email'}
                    radius="md"
                />

                <PasswordInput
                    required
                    withAsterisk={false}
                    label={t('password_label')}
                    placeholder={t('password_label')}
                    {...form.getInputProps('password')}
                    radius="md"
                />

                <Group position="apart">
                    <Button type="submit" fullWidth loading={isLoading}>
                        {t('login_button')}
                    </Button>
                </Group>
            </Stack>
        </form>
    )
}
